// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"a57c18ec19e6e73a762a","147":"2a7345eb0ce2159403c9","199":"1e6f4a4083b3b9c09e9c","251":"e378f7d03891b9d696b4","352":"2371a9157052b2907368"}[chunkId] + ".js";
};